import { observer } from 'mobx-react-lite';
import FontBody1 from '../../../../../../components/fonts/font-body1/font-body1';
import { FONT_VARIANT } from '../../../../../../components/fonts/font-props';
import { FormField } from '../../../../../../components/form-field/form-field';
import { Input } from '../../../../../../components/inputs/input/input';
import ControlGroup from '../../../../../../components/layouts/control-group/control-group';
import useTranslation from '../../../../../../translation/hooks/translation-hook';
import Translation from '../../../../../../translation/translation';
import TranslationInput from '../../../../../../translation/translation-input/translation-input';
import { IQuestionTypeProps } from '../question-types-props';
import './numeric-stepper.scss';
import FollowUpQuestionStore from '../../../../stores/follow-up-question-store';


const StepperView: React.FC<{ initialValue?: number }> = ({ initialValue }) => {
    const formatNumber = (v:number|undefined) => {
        v = v ?? 0;
        if (v < 10) {
            return '0' + v;
        }
        return v;
    }
    return (
        <div className="answer-numeric-stepper">
            <div className="ans-ns-button">-</div>
            <div className="ans-ns-counter">
                <div></div>
                {formatNumber(initialValue)}
            </div>
            <div className="ans-ns-button">+</div>
        </div>
    )
}

const FuqNumericStepper: React.FC<IQuestionTypeProps> = observer(({
    // DICLAIMER: before migration to React 18, it was reusing `answerDefaultProps` from question-types-props.ts
    // TODO: discuss during CR
    question = {} as FollowUpQuestionStore,
    disabled = false,
    validationGroup
}) => {    
    const { defaultLocale, selectedLocale } = useTranslation();

    return (
        <>
           {!disabled && <ControlGroup>
                <div className="answer-stepper-values">

                    <FormField label="Default value">
                        <Input type="number" min={0} max={200} value={question?.stepperDefaultValue} onChange={v => question?.setStepperDefaultValue(v)} disabled={ defaultLocale !== selectedLocale } />
                    </FormField>

                    <FormField label="Min value">
                        <Input type="number" min={0} max={200} value={question?.stepperMinValue} onChange={v => question?.setStepperMinValue(v)} disabled={ defaultLocale !== selectedLocale } />
                    </FormField>

                    <FormField label="Max value">
                        <Input type="number" min={0} max={200} value={question?.stepperMaxValue} onChange={v => question?.setStepperMaxValue(v)} disabled={ defaultLocale !== selectedLocale } />
                    </FormField>

                </div>

                <FormField label="Hint">
                    <TranslationInput translationKey={question?.stepperHint} required validationGroup={validationGroup} />
                </FormField>
            </ControlGroup>}
            
            {disabled && <>
                <div className="answer-title">
                    <Translation Font={FontBody1} variant={FONT_VARIANT.BOLD} translationKey={question?.question as string} />
                    <Translation Font={FontBody1} translationKey={question?.instruction as string} />
                </div>
                <Translation translationKey={question?.stepperHint as string} Font={FontBody1} />
            </>}

            <div className={`answer-stepper-wrapper ${disabled ? 'disabled' : ''}`}>
                <StepperView initialValue={question?.stepperDefaultValue} />
            </div>

        
        </>
    )
});

export default FuqNumericStepper;
